import * as ActionTypes from '../ActionTypes';

export const GetWageReportAction = (params, callback) => {
    return {
        type: ActionTypes.WAGE_REPORT_GET_REQUEST,
        params,
        callback
    }
}

export const GetWageReportNotProcessedAction = (params) => {
    return {
        type: ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_REQUEST,
        params
    }
}

export const GetDailyWageReportAction = (params, callback) => {
    return {
        type: ActionTypes.DAILY_WAGE_REPORT_GET_REQUEST,
        params,
        callback
    }
}

export const GetDailyWageReportNotProcessedAction = (params) => {
    return {
        type: ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST,
        params
    }
}

export const GetContractualWageReportAction = (params, callback) => {
    return {
        type: ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_REQUEST,
        params,
        callback
    }
}

export const GetContractualWageReportNotProcessedAction = (params) => {
    return {
        type: ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_REQUEST,
        params
    }
}